import { render, staticRenderFns } from "./SupportActiveList.vue?vue&type=template&id=53285106&scoped=true"
import script from "./SupportActiveList.vue?vue&type=script&lang=js"
export * from "./SupportActiveList.vue?vue&type=script&lang=js"
import style0 from "./supportList.css?vue&type=style&index=0&id=53285106&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53285106",
  null
  
)

export default component.exports